module.exports = __webpack_public_path__ + "img/11.dacd44a7.jpg";